import Vue from 'vue';
import { COMMONGIFTURL, BALANCEAGREEMENTURL, COLLECTRENT, } from '../../constant/common-gift';
import batchImport from '../../components/contract/contract-batch-import.vue';
import { saveData, getData } from '../../utils/storage';
import singleImport from '../../components/contract/contract-single-import.vue';
import commonVideo from '../../components/console-common/common-video.vue';
import tooltip from '../../components/console-common/tooltip.vue';
import cookie from '../../cookie/cookie';
export default Vue.extend({
    name: 'login',
    components: {
        batchImport: batchImport,
        singleImport: singleImport,
        'el-common-video': commonVideo,
        'el-tooltip': tooltip,
    },
    computed: {
        balanceAgreementUrl: function () {
            return COMMONGIFTURL + BALANCEAGREEMENTURL;
        },
        collectRentUrl: function () {
            return COMMONGIFTURL + COLLECTRENT;
        },
    },
    data: function () {
        return {
            isShowHover: false,
            isShowCollectRent: false,
            usernameZh: '',
            activeName: 'first',
            contract: 'contract',
            isHiddenOnceTips: false,
            collectRentContent: {
                txt: '快速了解如何使用系统进行收租',
                top: '35px',
                left: '-44px',
            },
            balanceAgreementContent: {
                txt: '如需纸质签署，请点击下载授权书',
                top: '35px',
                left: '-47px',
            },
        };
    },
    created: function () {
        this.isHiddenOnceTips = getData('isHiddenOnceTips');
        saveData('isHiddenOnceTips', true);
        this.getUserName();
        this.initTooltips();
    },
    methods: {
        getCampaignList: function () { },
        getUserName: function () {
            this.usernameZh = cookie.getCookie('usernameZh');
        },
        initTooltips: function () {
            var agreement = getData("contractImportBalanceAgreement_" + this.usernameZh);
            this.isShowHover = agreement;
        },
        closeCallback: function () {
            this.initTooltips();
        },
    },
});
